import * as constants from './contract-list-constants';
import checkStatus from '../../../utils/checkStatus';
import R from 'ramda';
import { bulkDownloadS3File } from '../../actions';

const callApiGet = (url) => {
  return fetch(url, {
    method: 'get',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  })
    .then(checkStatus);
};
const callApiPut = (url, body) => {
  return fetch(url, {
    method: 'put',
    body,
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  })
    .then(checkStatus);
};
const callApiPost = (url, body) => {
  return fetch(url, {
    method: 'post',
    body,
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  })
    .then(checkStatus);
};
const callApiDelete = (url, body) => {
  return fetch(url, {
    method: 'delete',
    body,
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  })
    .then(checkStatus);
};
export const downloadContractPdf = ({ docId, contractIds, files, zipFileName, zipNameWhenFileExists, anchorEl }) => (dispatch, getState) => {
  if (files && files.length) {
    bulkDownloadS3File(files, zipNameWhenFileExists);
  } else {
    dispatch({
      type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
      payload: {
        docId,
        contractIds,
        zipFileName,
        collection: 'contract',
        anchorEl,
      },
    });
  }
};

export const downloadPdfZip = (event) => (dispatch, getState) => {
  const contractIds = getState().contracting.contractList.get('selectedContracts').toJS();
  dispatch({
    type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
    payload: {
      contractIds,
      collection: 'contract',
      anchorEl: event.currentTarget,
      isBulk: true,
    },
  });
};
export const markAsViewed = contractId => {
  return callApiPut(`/proxy/contracting/contractViewed/${contractId}`, JSON.stringify({}));
};
export const getContractList = (doNotShowLoadingOverlay) => ({
  type: constants.LOAD_LIST,
  payload: !doNotShowLoadingOverlay,
});

export const selectCurrentAll = (payload) => {
  return dispatch => {
    dispatch({ type: constants.LOADING_LIST, payload: true });
    return callApiPost(`/proxy/contracting/contracts`, JSON.stringify(R.merge(payload, { getContractIds: true })))
      .then(res => res.json())
      .then(contractIds => {
        dispatch({ type: constants.SELECT_CURRENT_ALL, payload: { allContractIds: contractIds } });
        dispatch({ type: constants.LOADING_LIST, payload: false });
      })
      .catch(err => {
        dispatch({ type: constants.LOADING_LIST, payload: false });
        const permissionDenied = R.pathOr(0, ['response', 'status'], err) === 403;
        dispatch({
          type: 'GLOBAL_ERROR_TRIGGERED',
          payload: permissionDenied ? { noAccessDialog: true } : { errorMessage: 'Select all failed' },
        });
      });
  };
};
export const stateChange = (contractIds, newState) => {
  return dispatch => {
    dispatch({ type: constants.LOADING_LIST, payload: true });
    return callApiPut(`/proxy/contracting/updateContractStatus`, JSON.stringify({ contractIds, state: newState }))
      .then(() => {
        dispatch({ type: constants.STATE_CHANGE, payload: { contractIds, newState } });
        dispatch({ type: constants.LOADING_LIST, payload: false });
      })
      .catch(err => {
        dispatch({ type: constants.LOADING_LIST, payload: false });
        const permissionDenied = R.pathOr(0, ['response', 'status'], err) === 403;
        dispatch({
          type: 'GLOBAL_ERROR_TRIGGERED',
          payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to change contract status.' } : { errorMessage: 'Update status failed' },
        });
      });
  };
};

export const getContractFolders = () => {
  return dispatch => {
    dispatch({ type: constants.UPDATE_PROPS, payload: { folderLoading: true } });
    return callApiGet(`/proxy/contracting/contract-list/folder`)
    .then(res => res.json())
    .then(res => {
      dispatch({
        type: constants.UPDATE_PROPS,
        payload: {
          folders: res.folders,
          hideContractInFolder: res.hideContractInFolder,
          folderLoading: false,
        },
      });
    })
    .catch(err => {
      console.log(err.stack);
      dispatch({ type: constants.UPDATE_PROPS, payload: { folderLoading: false } });
    });
  };
};

export const manageFolders = payload => {
  return dispatch => {
    return callApiPut(`/proxy/contracting/old-assignFolder`, JSON.stringify(payload))
      .then(() => dispatch({ type: constants.MASS_ASSIGN_FOLDER, payload }))
      .catch(err => {
        const permissionDenied = R.pathOr(0, ['response', 'status'], err) === 403;
        dispatch({
          type: 'GLOBAL_ERROR_TRIGGERED',
          payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to move contracts to folders.' } : { errorMessage: 'Move to folder failed.' },
        });
      });
  };
};


/*
 toTrash: Boolean
 */
export const moveToTrashOrRestore = (toTrash, contractIds) => {
  return dispatch => {
    return callApiPut(`/proxy/contracting/deleteOrUndelete`, JSON.stringify({ contractIds, state: toTrash }))
      .then(() => dispatch({ type: constants.MASS_DELETE_RESTORE, payload: { contractIds, state: toTrash } }))
      .catch(err => {
        const permissionDenied = R.pathOr(0, ['response', 'status'], err) === 403;
        dispatch({
          type: 'GLOBAL_ERROR_TRIGGERED',
          payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to perform this action.' }
          : { errorMessage: toTrash ? 'Move to trash failed.' : 'Restore failed' },
        });
      });
  };
};

export const moveToArchiveOrRestore = (toArchived, contractIds) => {
  return dispatch => {
    return callApiPut(`/proxy/contracting/archiveOrUnarchive`, JSON.stringify({ contractIds, state: toArchived }))
      .then(() => dispatch({ type: constants.MASS_ARCHIVE_OR_RESTORE, payload: { contractIds, state: toArchived } }))
      .catch(err => {
        const permissionDenied = R.pathOr(0, ['response', 'status'], err) === 403;
        dispatch({
          type: 'GLOBAL_ERROR_TRIGGERED',
          payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to perform this action.' }
            : { errorMessage: toArchived ? 'Move to archived failed.' : 'Restore failed' },
        });
      });
  };
};

export function saveNewFolder(folderName) {
  return dispatch => {
    return callApiPost(`/proxy/contracting/contract-list/folder`, JSON.stringify({ folderName }))
      .then(() => dispatch({ type: constants.CREATE_FOLDER, payload: folderName }))
      .catch(err => {
        const permissionDenied = R.pathOr(0, ['response', 'status'], err) === 403;
        dispatch({
          type: 'GLOBAL_ERROR_TRIGGERED',
          payload: permissionDenied ? { noAccessDialog: true }
            : { errorMessage: 'Create folder failed.' },
        });
      });
  };
}
export function changeRoute(routeName, isFolder) {
  return { type: '[contract-list]CHANGE_ROUTE', payload: { routeName, isFolder } };
}
export function updateFolders({ folders, originalFolder, newFolderName }) {
  return ({ type: constants.UPDATE_FOLDER_NAME, payload: { folders, originalFolder, newFolderName } });
}

export function deleteFolder(folderName) {
  return dispatch => {
    return callApiDelete(`/proxy/contracting/contract-list/folder`, JSON.stringify({ folderName }))
      .then(() => dispatch({ type: constants.DELETE_FOLDER, payload: folderName }))
      .catch(err => {
        const permissionDenied = R.pathOr(0, ['response', 'status'], err) === 403;
        dispatch({
          type: 'GLOBAL_ERROR_TRIGGERED',
          payload: permissionDenied ? { noAccessDialog: true }
            : { errorMessage: 'Delete folder failed.' },
        });
      });
  };
};


export function showFreeContractDialogAction(activiesOrDetails, contractId) {
  const url = `/contracting/contract/${contractId}/${activiesOrDetails}`;
  return {
    type: constants.SHOW_FREE_CONTRACT_DIALOG,
    payload: {
      url,
      contractId,
    },
  };
}
const toggleBulkResendDialog = open => ({ type: constants.TOGGLE_BULK_RESEND_DIALOG, payload: open });
export const closeBulkResendDialog = () => toggleBulkResendDialog(false);
export const openBulkResendDialog = () => (dispatch, getState) => {
  const contractIds = getState().contracting.contractList.get('selectedContracts').toJS();
  const companyType = getState().user.getIn(['user', 'type']);
  const companyName = getState().user.getIn(['company', 'companyName']);
  dispatch(toggleBulkResendDialog(true));
  return callApiPost('/proxy/contracting/groupContractsForBulkResend', JSON.stringify({ contractIds }))
    .then(res => res.json())
    .then(result => {
      dispatch({ type: constants.POPULATE_BULK_RESEND, payload: {
        partners: result,
        subject: `Rates Reminder: ${companyName}`,
        customizedMessage: companyType === 'Supplier' ? `For your convenience, I'm resending rates for ${companyName} via TourConnect.`
          : `If you have not done so already, this is a friendly reminder that we need your rates.  Using TourConnect will make it easier for us to load your rates. More importantly, it will help us sell more of your products.`,
      } });
    })
    .catch(err => {
      const permissionDenied = R.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to resend contracts.' }
          : { errorMessage: 'Failed to get data for bulk resending.' },
      });
    });
};
export const bulkResend = () => (dispatch, getState) => {
  const { partners, customizedMessage, BCCToSelf } = getState().contracting.contractList.get('bulkResendDialog').toJS();
  dispatch({ type: constants.BULK_SENDING });
  return callApiPut('/proxy/contracting/bulkResendContracts', JSON.stringify({ partners, customizedMessage, BCCToSelf }))
  .then(() => dispatch({ type: constants.BULK_SEND_FINISHED }))
  .catch(err => {
    console.log(err.stack);
    dispatch({ type: constants.BULK_SEND_FINISHED });
    dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: { errorMessage: 'Failed to resend contracts in bulk.' } });
  });
};
export const updateBulkResendDialogProps = payload => ({ type: constants.UPDATE_BULK_RESEND_PROPS, payload });
export const updateProps = payload => ({ type: constants.UPDATE_PROPS, payload });
export const updateSearchParams = payload => ({ type: constants.UPDATE_PARAMS, payload });
export const resetSearchParams = () => ({ type: constants.RESET_PARAMS });

export const selectAContract = id => ({ type: constants.SELECT_ONE_CONTRACT, payload: id });
export const openResendContractDialog = payload => ({ type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE', payload });
export const getContractForwardingEmail = payload => ({ type: constants.GET_CONTRACT_EMAIL, payload });



// WEBPACK FOOTER //
// ./src/app/stores/contracting/contract-list/contract-list-actions.js